import { IProgressGPTChatModel, ProgressGPTReplyModel } from 'api/models';
import { getApiUrl } from 'config/api-url';
import http from 'config/http';

/* -------------------------------------------------------------------------------------------------
 * Get All chats
 * -----------------------------------------------------------------------------------------------*/

export const getProgressGPTChats = async () => {
    const { data } = await http.get(`${getApiUrl()}/progressgpt/chats`);

    return data as IProgressGPTChatModel[];
};

/* -------------------------------------------------------------------------------------------------
 * Get replies
 * -----------------------------------------------------------------------------------------------*/

export const getProgressGPTReplies = async (chatId: string) => {
    const { data } = await http.get(`${getApiUrl()}/progressgpt/chats/${chatId}/replies`);

    return ProgressGPTReplyModel.fromObjectList(data);
};

/* -------------------------------------------------------------------------------------------------
 * Create Chat
 * -----------------------------------------------------------------------------------------------*/

export const createProgressGPTChat = async (payload: Pick<ProgressGPTReplyModel, 'message'>) => {
    const { data } = await http.post(`${getApiUrl()}/progressgpt/chats`, payload);

    return data as IProgressGPTChatModel;
};

/* -------------------------------------------------------------------------------------------------
 * Add Reply
 * -----------------------------------------------------------------------------------------------*/

export const createProgressGPTReply = async (
    chatId: string,
    payload: Pick<ProgressGPTReplyModel, 'message' | 'chatId' | 'metadata'>
) => {
    const { data } = await http.post(`${getApiUrl()}/progressgpt/chats/${chatId}/replies`, payload);

    const result = {
        chatId: data.chatId,
        userReply: ProgressGPTReplyModel.fromObject(data.userReply),
        botReply: ProgressGPTReplyModel.fromObject(data.botReply),
    };

    return result;
};

/* -------------------------------------------------------------------------------------------------
 * Delete Chats
 * -----------------------------------------------------------------------------------------------*/

export const deleteProgressGPTChat = async (chatId: string) => {
    await http.delete(`${getApiUrl()}/progressgpt/chats/${chatId}`);
};

/* -------------------------------------------------------------------------------------------------
 * Get Suggestions
 * -----------------------------------------------------------------------------------------------*/

export const getProgressGPTSuggestions = async () => {
    const { data } = await http.get(`${getApiUrl()}/progressgpt/chats/suggestions`);

    return data as {
        id: string;
        title: string;
        message: string;
    }[];
};
